import type {
  GetFilterFieldsQuery,
  GetSurveyQuery,
} from 'src/gql/tal/generated';
import type {
  Driver,
  DriverList,
  DriverOption,
} from './components/QueryFilter';

export interface DatalabQueryParams {
  primaryDriver: string;
  primaryDriverOptions?: string[];
  secondaryDriver?: string;
  secondaryDriverOptions?: string[];
}

export interface DatalabSurvey {
  queryFilters: GetFilterFieldsQuery;
  surveyResults: GetSurveyQuery;
  queryFilterParams: DatalabQueryParams;
}

const driversMap: Map<string, string> = new Map([
  ['industries', 'Industry'],
  ['genders', 'Gender'],
  ['senioritys', 'Seniority'],
  ['generations', 'Generation'],
  ['locations', 'Location'],
  ['workTypes', 'Work type'],
]);

const getQueryFilterParams = (
  queryParams: URLSearchParams,
): DatalabQueryParams => ({
  primaryDriver: queryParams.get('primaryDriver') || 'ALL',
  primaryDriverOptions: queryParams.getAll('primaryDriverOptions'),
  secondaryDriver: queryParams.get('secondaryDriver') || undefined,
  secondaryDriverOptions: queryParams.getAll('secondaryDriverOptions'),
});

const getDriverListFrom = (queryFilter: GetFilterFieldsQuery): DriverList => {
  const entries = Object.entries(queryFilter);
  const drivers = entries.map(
    ([key, values]) =>
      ({
        name: driversMap.get(key),
        options: values.map((value: DriverOption) => ({ name: value.name })),
      } as Driver),
  );

  return {
    drivers,
  };
};

interface SyncDriverList {
  primaryDrivers: DriverList;
  secondaryDrivers: DriverList;
  selectedPrimaryDriver: string;
}

const updateSecondaryDriverList = ({
  primaryDrivers,
  secondaryDrivers,
  selectedPrimaryDriver,
}: SyncDriverList) => {
  secondaryDrivers.drivers = primaryDrivers.drivers.filter(
    (driver) => driver.name !== 'ALL' && driver.name !== selectedPrimaryDriver,
  );
};

export const dataLabHelper = {
  getDriverListFrom,
  getQueryFilterParams,
  updateSecondaryDriverList,
};
